import { Component , HostListener} from '@angular/core';
import { DataService } from '../../../core/services/data/data.service';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [ RouterLink , NgClass],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {

  constructor( private DataService : DataService ) {}

  isArabic = false ;

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
    }
    else {
      this.isArabic = false ;
    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }

  isScaled = false;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    // Get the vertical scroll position
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // Adjust this threshold as needed
    const threshold = 200; 

    if (scrollTop > threshold) {
      this.isScaled = true;
    } else {
      this.isScaled = false;
    }
  }

  ngOnInit(): void { 

    this.changeLang() ;
  
  }

}
